<ng-container>
  <div class="ppl-container-body">
    <div class="ppl-container-head">
      <div class="details-header">
        <ppl-button
          label="Back"
          icon="fa fa-chevron-left"
          [customClass]="'ghost-button'"
          iconPosition="left"
          (click)="goBack()">
        </ppl-button>
        <h1 class="page-title-accessibility">Bulk Adjustment Error List</h1>
      </div>
    </div>
    <div class="ppl-container">
      <div class="ppl-content-container">
        <div class="table-style">
          @if (programName) {
            <ppl-list-table
              [pageConfig]="programName"
              [loadPage]="lazyLoad"
              [sharedDataKey]="sharedDataKey"
              [jsonList]="'list_mass_adjustments_errors'"
              [tableWidth]="'100%'"
              [tableScrollable]="true"
              tableScrollHeight="flex"
              [dataLoader]="massAdjustmentsDataLoader"
              [recordsPerPage]="20"
              [enableActions]="false"
              [showFullContent]="true"
            >
            </ppl-list-table>
          }
        </div>
      </div>
    </div>
  </div>
</ng-container>